import React from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Cards from 'components/Card';
import CardTemplate from 'pages/Consultants/components/CardTemplate';
const Background = styled('section')(({ theme }) => ({
  backgroundColor: theme.palette.backgroundLight.main,
  borderBottom: `2px solid ${theme.palette.primary.main}`
}));

const ContentWrapper = styled('div')(({ theme }) => ({
  padding: '60px 100px',
  ...theme.wrapper,
  maxWidth: 1240,
  [theme.breakpoints.down('lg')]: {
    padding: 50
  },
  [theme.breakpoints.down('md')]: {
    padding: 30,
    flexDirection: 'column'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '40px 20px'
  }
}));

const SubTitle = styled(Typography)(({ theme }) => ({
  marginBottom: 30,
  fontSize: 30,
  lineHeight: '40px',
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
    lineHeight: '32px',
    marginBottom: 20
  }
}));

const ButtonStyledRedirect = styled(Button)(({ theme }) => ({
  display: 'block',
  borderRadius: 8,
  margin: '0 auto',
  marginTop: 40,
  [theme.breakpoints.down('md')]: {
    marginTop: 20
  }
}));

const OtherConsultants = ({ consultants, handleRedirect }) => {
  const t = useTranslate('Consultant');

  const cardTemplate = React.useCallback((item) => <CardTemplate t={t} item={item} />, [t]);

  if (!(consultants || []).length) {
    return null;
  }

  return (
    <Background>
      <ContentWrapper>
        <SubTitle variant={'h2'}>{t('OtherConsultants')}</SubTitle>
        <Cards list={consultants} template={cardTemplate} endPoint="consultants" />
        <ButtonStyledRedirect
          aria-label={t('MoreConsultants')}
          variant="contained"
          color="primary"
          onClick={(event) => {
            handleRedirect(event);
            import('services/analytics').then(({ default: A }) => A.event('MoreConsultantsClick'));
          }}>
          {t('MoreConsultants')}
        </ButtonStyledRedirect>
      </ContentWrapper>
    </Background>
  );
};

export default OtherConsultants;
